/**
 * Checks if a number is even.
 * @param num - The number to check
 */
export function isEven(num: number): boolean {
  return num % 2 === 0;
}
